import React, { useState } from "react";
import { Table, Spinner, Input } from "reactstrap";

const CommonTable = ({
  columns = [],
  data = [],
  loading = false,
  selectable = false,
  onRowClick,
  onEdit,
  onToggle,
  selectedRows = [],
  setSelectedRows,
}) => {
  const [selectAll, setSelectAll] = useState(false);

  // 🔹 select all
  const handleSelectAll = () => {
    if (!selectAll) {
      setSelectedRows(data.map((d) => d._id));
    } else {
      setSelectedRows([]);
    }
    setSelectAll(!selectAll);
  };

  // 🔹 single select
  const handleSelect = (id) => {
    if (selectedRows.includes(id)) {
      setSelectedRows(selectedRows.filter((i) => i !== id));
    } else {
      setSelectedRows([...selectedRows, id]);
    }
  };

  return (
    <div className="table-responsive">
      <Table className="table align-middle table-hover table-nowrap mb-0">
        <thead className="table-light">
          <tr>
            {selectable && (
              <th style={{ width: "40px" }}>
                <Input
                  type="checkbox"
                  checked={selectAll}
                  onChange={handleSelectAll}
                />
              </th>
            )}

            {columns.map((col, index) => (
              <th key={index}>{col.header}</th>
            ))}

            {/* ACTION COLUMN */}
            {(onEdit || onToggle) && <th>Actions</th>}
          </tr>
        </thead>

        <tbody>
          {loading ? (
            <tr>
              <td colSpan={columns.length + 2} className="text-center">
                <Spinner size="sm" /> Loading...
              </td>
            </tr>
          ) : data.length === 0 ? (
            <tr>
              <td colSpan={columns.length + 2} className="text-center">
                No Data Found
              </td>
            </tr>
          ) : (
            data.map((row) => (
              <tr
                key={row._id}
                style={{ cursor: onRowClick ? "pointer" : "default" }}
                onClick={() => onRowClick && onRowClick(row)}
              >
                {/* CHECKBOX */}
                {selectable && (
                  <td onClick={(e) => e.stopPropagation()}>
                    <Input
                      type="checkbox"
                      checked={selectedRows.includes(row._id)}
                      onChange={() => handleSelect(row._id)}
                    />
                  </td>
                )}

                {/* DATA COLUMNS */}
                {columns.map((col, index) => (
                  <td key={index}>
                    {col.render
                      ? col.render(row)
                      : row[col.accessor] || "-"}
                  </td>
                ))}

                {/* ACTIONS */}
                {(onEdit || onToggle) && (
                  <td onClick={(e) => e.stopPropagation()}>
                    <div className="d-flex gap-2">
                      {onEdit && (
                        <i
                          className="mdi mdi-pencil text-primary cursor-pointer"
                          style={{ cursor: "pointer" , fontSize:"22px" }}
                          onClick={() => onEdit(row)}
                        />
                      )}

                      {onToggle && (
                        <i
                          className={`mdi ${
                            row.isActive
                              ? "mdi-toggle-switch"
                              : "mdi-toggle-switch-off"
                          } text-warning`}
                          style={{ cursor: "pointer" , fontSize:"24px" }}
                          onClick={() => onToggle(row)}
                        />
                      )}
                    </div>
                  </td>
                )}
              </tr>
            ))
          )}
        </tbody>
      </Table>
    </div>
  );
};

export default CommonTable;